import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Space, Row, Col, Select } from 'antd';
import { CheckOutlined, PlusOutlined } from '@ant-design/icons'
import { useB2cNextCode, useB2cStudentDetail } from 'hooks';
import { CompanySelectBox, CrmSelectBox } from 'components/atoms'
import moment from 'moment';
import { DatePicker } from 'components/atoms';
import { QuotationItemModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';

export interface QuotationMakeModalProps extends PopupProps {
    lectureInfo: LectureInfoDto;
    studentCnt: number;
    company: number;
}

const QuotationMakeModal = ({ 
    isOpen, 
    onClose, 
    lectureInfo, studentCnt, company}: QuotationMakeModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
   const [quotationInfo, setQuotationInfo] = useState<QuotationInfoDto>({
        app_srl: 0,
        company_srl: company,
        company_name: '',
        sale_price: 0,    
        total_price: 0,
        quote_date: ''
    });  
    const [quotationItems, setQuotationItems] = useState<QuotationItemDto[]>([]);

  /* ======================================================
  * hooks
  * ====================================================== */

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { open } = usePopupManager();
   /* ======================================================
   * events
   * ====================================================== */

    const onSubmit = (e) => {
        if (!!quotationInfo && !!quotationItems && quotationItems.length > 0) {
            axios({
            url: SERVER_URL + endpoints.b2c.quotation.insert,
            method: 'post',
            headers: {
                    'Content-Type': 'application/json'
                },            
            data: {
                app_srl: 0,
                company_srl: quotationInfo.company_srl,
                company_name: quotationInfo.company_name,
                sale_price: quotationInfo.sale_price,
                total_price: quotationInfo.total_price,
                quote_date: form.getFieldValue('quote_date'),
                title: form.getFieldValue('quote_title'),
                items: quotationItems                
            },
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.code == 200) {
                        const student_id = response.data.result.id;
                        onClose?.(true, student_id);
                    }
                }                
            }); 
                        
 
        }
    };

    const onCloseClick = () => {
        onClose?.(false);
    }
    
    const onItemInsertPopup = () => {
        open(QuotationItemModal, { 
          onClose: (isOk, item) => {
            if (isOk) {   
                setQuotationItems((prev)=>{
                    return [...prev, item];
                })  
            };
          },          
        }); 
    }

  /* ======================================================
   * effects
   * ====================================================== */
    
    useEffect(() => {
        setQuotationInfo(prev=> {
            return {
                ...prev, 
                company_srl: company, 
                sale_price: lectureInfo.lecture_price * studentCnt,
                total_price: Number(((lectureInfo.lecture_price * studentCnt) * 1.1).toFixed(0))
            }});
        if (studentCnt > 0) {
            const newItem = {
                title: `${lectureInfo.lecture_name? lectureInfo.lecture_name: lectureInfo.lecture_title} (${lectureInfo.start_date}~${lectureInfo.end_date})`,
                num: studentCnt,
                price: lectureInfo.lecture_price * studentCnt,  
                memo: ''
            };
            setQuotationItems([newItem])
        }
    }, [])  
    
    useEffect(() => {
        if (quotationItems) {
            let sale_price = 0;
            quotationItems.forEach((dto)=>{
                sale_price += Number(dto.price) || 0;
            })
            setQuotationInfo(prv=> {return {...prv, sale_price: sale_price, total_price: Number((sale_price * 1.1).toFixed(0))}});
        }
    }, [quotationItems])     

    

    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={800} title={'견적서발행'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
                initialValues={{quote_date: moment().format('YYYY-MM-DD')}}
            >
                <Form.Item 
                    name="quote_title" 
                    label={'문서 선택'} 
                    rules={[{ required: true, message: '' }]}
                >
                    <Select placeholder="문서 선택">
                        <Select.Option value={'견적서'}>견적서</Select.Option>
                        <Select.Option value={'거래명세서'}>거래명세서</Select.Option>
                    </Select>     
                </Form.Item>                 
                <Form.Item 
                    name="quote_date" 
                    label={'발행 일자'} 
                    rules={[{ required: true, message: '' }]}
                    getValueProps={(i) => ({value: i!=='Invalid date'? moment(i): ''})}
                    getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}                    
                >
                    <DatePicker 
                        showTime={false}
                        format="YYYY-MM-DD"
                    />  
                </Form.Item> 

                <Form.Item name="company_srl" label={'고객사(기업명)'} rules={[{ required: true, message: '' }]}>
                    <CompanySelectBox required={true} form={form} company_srl={quotationInfo.company_srl} onSelected={(value, option) => {setQuotationInfo(prev=> {return {...prev, company_srl: Number(value), company_name:option.label}});}} />
                </Form.Item>  
                <Form.Item label={'품목'}>
                    {quotationItems.map((item)=>(
                        <Row key={item.title} style={{borderBottomWidth:'0.5px', borderBottomStyle:'solid', borderBottomColor:'#ccc', paddingBottom:3}}>
                            <Col span={13}>
                                <span>{item.title}</span>
                            </Col>
                            <Col span={2} style={{textAlign:'center'}}>
                                <span>{`${item.num} 명`}</span>
                            </Col>   
                            <Col span={3} style={{textAlign:'end', paddingRight: 5}}>
                                <span>{(item.price * 1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                            </Col>  
                            <Col span={4}>
                                <span>{item.memo}</span>
                            </Col>                              
                            <Col span={2} style={{width:'fit-content', marginLeft:'auto'}}>
                                <Button 
                                    size='small' 
                                    type="default" 
                                    onClick={() => 
                                        setQuotationItems((prev)=>{
                                            const newItems = prev.filter((dto) => dto.title != item.title);
                                            return newItems;
                                        })
                                    }
                                >삭제</Button>
                            </Col>                                                                                 
                        </Row>
                    ))}
                    <Button 
                        size='small' 
                        type="default" 
                        icon={<PlusOutlined />}
                        style={{marginTop:5}}
                        onClick={onItemInsertPopup}
                    >추가</Button>                    
                </Form.Item>                 
                <Form.Item label={'합계 금액'}>
                    <label>{quotationInfo.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCloseClick} style={{marginRight: "5px"}}>취소</Button>                    
                    <Button htmlType="submit"  type="primary">{'발행'}</Button>                    
                </ButtonGroup>                 
            </Form>
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(QuotationMakeModal);    